export const StorageKeys = {
    deviceId: 'DI',
    loggedInUserId: 'LUI',
    devMode: 'devMode'
}
